<script lang="ts">
  // Culture toggle — flips the active i18n culture between the default (English)
  // catalogue and the shipped vi-VN translation
  // (wiki/feature-resource-generation.md §Localization). Reads + writes the
  // shared culture store, which persists the choice and mirrors it onto the
  // document `lang` attribute. Matches the ThemeToggle's corner-control chrome.
  import { activeCulture, setCulture, t, type Culture } from '$lib/i18n';
  import { UiKeys } from '@voicedojo/backend-types';

  let { onswitch }: { onswitch?: (culture: Culture) => void } = $props();

  const isVietnamese = $derived(activeCulture() === 'vi-VN');

  function switchTo(culture: Culture) {
    setCulture(culture);
    onswitch?.(culture);
  }
</script>

<button
  type="button"
  class="vd-culture-toggle"
  aria-label={t(UiKeys.Culture.ToggleAria)}
  aria-pressed={isVietnamese}
  title={isVietnamese ? t(UiKeys.Culture.English) : t(UiKeys.Culture.Vietnamese)}
  onclick={() => switchTo(isVietnamese ? 'default' : 'vi-VN')}
>
  {isVietnamese ? t(UiKeys.Culture.VietnameseShort) : t(UiKeys.Culture.EnglishShort)}
</button>

<style lang="scss">
  .vd-culture-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 10px;
    border: 1px solid var(--line);
    background: transparent;
    color: var(--ink-soft);
    cursor: pointer;
    font-family: var(--font-ui);
    font-size: var(--text-label);
    font-weight: 700;
    letter-spacing: 0.03em;
    transition:
      border-color 0.2s ease,
      color 0.2s ease;

    &:hover {
      border-color: var(--accent);
      color: var(--accent-text);
    }

    &:focus-visible {
      outline: 2px solid var(--accent-text);
      outline-offset: 2px;
    }
  }
</style>
